<template>
  <div @click="toggle" class="ml-steps__item">
    <step :completed="completed" :show="show" @close="toggle">
      <div class="ml-steps-card__title">{{$t("generic.listName")}}</div>
      <template v-slot:icon>
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.78267 12.2175C2.71135 12.1492 2.62724 12.0957 2.53517 12.06C2.35258 11.985 2.14777 11.985 1.96517 12.06C1.87311 12.0957 1.789 12.1492 1.71767 12.2175C1.64939 12.2888 1.59587 12.3729 1.56017 12.465C1.50274 12.6016 1.48705 12.7521 1.51508 12.8976C1.54311 13.0431 1.61361 13.177 1.71767 13.2825C1.79058 13.3487 1.87429 13.402 1.96517 13.44C2.05495 13.4797 2.15202 13.5002 2.25017 13.5002C2.34833 13.5002 2.4454 13.4797 2.53517 13.44C2.62606 13.402 2.70977 13.3487 2.78267 13.2825C2.88674 13.177 2.95724 13.0431 2.98527 12.8976C3.0133 12.7521 2.99761 12.6016 2.94017 12.465C2.90448 12.3729 2.85095 12.2888 2.78267 12.2175ZM5.25017 6H15.7502C15.9491 6 16.1399 5.92098 16.2805 5.78033C16.4212 5.63968 16.5002 5.44891 16.5002 5.25C16.5002 5.05109 16.4212 4.86032 16.2805 4.71967C16.1399 4.57902 15.9491 4.5 15.7502 4.5H5.25017C5.05126 4.5 4.8605 4.57902 4.71984 4.71967C4.57919 4.86032 4.50017 5.05109 4.50017 5.25C4.50017 5.44891 4.57919 5.63968 4.71984 5.78033C4.8605 5.92098 5.05126 6 5.25017 6ZM2.78267 8.4675C2.67721 8.36343 2.54328 8.29293 2.39778 8.2649C2.25229 8.23687 2.10176 8.25257 1.96517 8.31C1.87429 8.34798 1.79058 8.40125 1.71767 8.4675C1.64939 8.53883 1.59587 8.62294 1.56017 8.715C1.5205 8.80478 1.5 8.90185 1.5 9C1.5 9.09815 1.5205 9.19522 1.56017 9.285C1.59816 9.37589 1.65143 9.4596 1.71767 9.5325C1.79058 9.59875 1.87429 9.65202 1.96517 9.69C2.05495 9.72968 2.15202 9.75017 2.25017 9.75017C2.34833 9.75017 2.4454 9.72968 2.53517 9.69C2.62606 9.65202 2.70977 9.59875 2.78267 9.5325C2.84892 9.4596 2.90219 9.37589 2.94017 9.285C2.97985 9.19522 3.00035 9.09815 3.00035 9C3.00035 8.90185 2.97985 8.80478 2.94017 8.715C2.90448 8.62294 2.85095 8.53883 2.78267 8.4675ZM15.7502 8.25H5.25017C5.05126 8.25 4.8605 8.32902 4.71984 8.46967C4.57919 8.61032 4.50017 8.80109 4.50017 9C4.50017 9.19891 4.57919 9.38968 4.71984 9.53033C4.8605 9.67098 5.05126 9.75 5.25017 9.75H15.7502C15.9491 9.75 16.1399 9.67098 16.2805 9.53033C16.4212 9.38968 16.5002 9.19891 16.5002 9C16.5002 8.80109 16.4212 8.61032 16.2805 8.46967C16.1399 8.32902 15.9491 8.25 15.7502 8.25ZM2.78267 4.7175C2.71135 4.64922 2.62724 4.5957 2.53517 4.56C2.39859 4.50257 2.24806 4.48687 2.10256 4.5149C1.95707 4.54293 1.82314 4.61343 1.71767 4.7175C1.65143 4.7904 1.59816 4.87411 1.56017 4.965C1.5205 5.05478 1.5 5.15185 1.5 5.25C1.5 5.34815 1.5205 5.44522 1.56017 5.535C1.59816 5.62589 1.65143 5.7096 1.71767 5.7825C1.79058 5.84875 1.87429 5.90202 1.96517 5.94C2.10176 5.99743 2.25229 6.01313 2.39778 5.9851C2.54328 5.95707 2.67721 5.88657 2.78267 5.7825C2.84892 5.7096 2.90219 5.62589 2.94017 5.535C2.97985 5.44522 3.00035 5.34815 3.00035 5.25C3.00035 5.15185 2.97985 5.05478 2.94017 4.965C2.90219 4.87411 2.84892 4.7904 2.78267 4.7175ZM15.7502 12H5.25017C5.05126 12 4.8605 12.079 4.71984 12.2197C4.57919 12.3603 4.50017 12.5511 4.50017 12.75C4.50017 12.9489 4.57919 13.1397 4.71984 13.2803C4.8605 13.421 5.05126 13.5 5.25017 13.5H15.7502C15.9491 13.5 16.1399 13.421 16.2805 13.2803C16.4212 13.1397 16.5002 12.9489 16.5002 12.75C16.5002 12.5511 16.4212 12.3603 16.2805 12.2197C16.1399 12.079 15.9491 12 15.7502 12Z"
            fill="#424142"
          />
        </svg>
      </template>
      <template v-slot:modal>
        <div class="card-wizard">
          <div class="card-wizard__title">
            <h3 class="header-3">{{$t("generic.listName")}}</h3>
            <div class="card-wizard__subtitle">
              {{ $t("mylist.widgetListTitle") }}
            </div>
          </div>

          <form class="card-wizard__container">
            <div class="bb-form-item bb-form-item--left w-100">
              <label for="title" class="bb-form-label">
                {{$t("generic.listName")}}
              </label>
              <input
                v-model="title"
                class="bb-form"
                type="text"
                maxlength="256"
                name="title"
                id="title"
                required=""
              />
            </div>

            <div class="card-wizard__actions">
              <loading-button v-if="loading"></loading-button>
              <button
                v-else
                class="button button--primary button--block"
                @click.prevent="save"
                :disabled="title === ''"
              >
                {{ $t("generic.save") }}
              </button>
            </div>
          </form>
        </div>
      </template>
    </step>
    <alert v-if="showAlertLocal" @retry="retry" :key="key" />
  </div>
</template>

<script>
import Step from "./Step";
import LoadingButton from "../../../components/LoadingButton";
import { mapGetters } from "vuex";
import OwnerListAlert from "./OwnerListAlert";

export default {
  name: "ListTitleStep",
  components: {
    Step,
    "loading-button": LoadingButton,
    alert: OwnerListAlert,
  },
  data() {
    return {
      show: false,
      title: "",
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      list: "ownerList",
      showAlertKey: "showAlertKey",
      showAlert: "showAlert",
    }),
    completed() {
      return (
        this.list.title !== "" &&
        this.list.title != null &&
        this.list.title != this.$t("mylist.defaultListName")
      );
    },
    showAlertLocal() {
      return this.showAlertKey === this.key && this.showAlert;
    },
    key() {
      return "list_litle_step";
    },
  },
  methods: {
    async retry() {
      this.$store.commit("setAlertRetrying", true);
      await this.save();
      this.$store.commit("setAlertRetrying", false);
    },
    toggle() {
      this.show = !this.show;
    },
    async save() {
      this.loading = true;
      try {
        await this.$store.dispatch('updateListTitle', { list: this.list, title: this.title})
      } catch {
        this.loading = false;
        this.show = false;
        this.$alert.error(
          this.$t("mylist.widgetListTitleError"),
          true,
          this.key
        );
        return;
      }
      this.$store.commit("updateOwnerListTitle", this.title);
      this.loading = false;
      window.mixpanel.track("Onboarding", {
        "Step Name": "Step List Title",
        Skipped: false,
        "Last O Slide": false,
        "On Seq Com": false,
      });
      window.mixpanel.people.increment("Steps Taken");
      this.show = false;
      this.$alert.success(
        this.$t("mylist.widgetListTitleSuccess"),
        this.key
      );
      this.$emit("updated");
    },
  },
  mounted() {
    this.title = this.list.title || this.$t("mylist.defaultListName");
  },
  watch: {
    //if this.list changes, update the title
    list: {
      handler() {
        this.title = this.list.title || this.$t("mylist.defaultListName");
      },
      deep: true,
    },
  }
};
</script>
